import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SendOutlined } from '@ant-design/icons';

import { Modal } from 'redpoints-front-components';

import { linksManagementRelaunchEnforcement } from '../../../actions/linksManagementActions';
import {
  getLinksManagementLinksContentLinkUrlsIntroduced,
  getLinksManagementLinksDetectionLinkUrlsIntroduced,
} from '../../../reducers/tasks/linksManagement';
import LinksManagementViewerActionsButton from './LinksManagementViewerActionsButton';
import { translate } from '../../../helpers/languageHelper';
import { generateUrlsList } from './linksManagementHelpers';

const LinksManagementRelaunchEnforcementAction = ({
  disabled,
  validateFields,
}) => {
  const dispatch = useDispatch();

  const [
    showRelaunchEnforcementModal,
    setShowRelaunchEnforcementModal,
  ] = useState(false);

  const detectionLinkUrls = useSelector(
    getLinksManagementLinksDetectionLinkUrlsIntroduced
  );
  const contentLinkUrls = useSelector(
    getLinksManagementLinksContentLinkUrlsIntroduced
  );

  const handleClickRelaunchEnforcementModal = useCallback(() => {
    validateFields()
      .then(() => {
        setShowRelaunchEnforcementModal(true);
      })
      .catch(error => console.error(error)); // eslint-disable-line no-console
  }, [validateFields]);

  const handleRelaunchEnforcement = () => {
    setShowRelaunchEnforcementModal(false);

    dispatch(
      linksManagementRelaunchEnforcement({
        detectionLinks: generateUrlsList(detectionLinkUrls),
        contentLinks: generateUrlsList(contentLinkUrls),
      })
    );
  };

  const handleCloseRelaunchEnforcementModal = () => {
    setShowRelaunchEnforcementModal(false);
  };

  return (
    <>
      <LinksManagementViewerActionsButton
        disabled={disabled}
        onClick={handleClickRelaunchEnforcementModal}
        title={translate('tasks.links_management.actions.relaunchEnforcement')}
      >
        <SendOutlined disabled={disabled} />
      </LinksManagementViewerActionsButton>

      <Modal
        className="rp-links-relaunch-enforcement-modal"
        okText={translate('actions.confirm')}
        onCancel={handleCloseRelaunchEnforcementModal}
        onOk={handleRelaunchEnforcement}
        visible={showRelaunchEnforcementModal}
      >
        {translate(
          'tasks.links_management.modal.relaunchEnforcementModalLabel'
        )}
      </Modal>
    </>
  );
};

export default LinksManagementRelaunchEnforcementAction;
